// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"4273d557","167":"3648c09a","306":"3f42c5e6","697":"d84f2429","784":"4b23c97e","977":"f982da03"}[chunkId] + ".chunk.js";
};